export const Admins = [
    'IAM_EmployeePortal_DEV_ADMIN',
    'IAM_EmployeePortal_STG_ADMIN',
    'IAM_EmployeePortal_PRD_ADMIN',
];